import { render, staticRenderFns } from "./OverviewList.vue?vue&type=template&id=1378c397&"
import script from "./OverviewList.vue?vue&type=script&lang=ts&"
export * from "./OverviewList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports